export default function cookieConsent(opts = {}) {
	return {
		analyticsId: opts.analyticsId,
		acceptedAnalytics: true,
		cookieName: opts.cookieName || 'cookie-prefs',
		cookieValue: null,
		prefs: false,
		show: false,

		init() {
			this.cookieValue = this.getCookie(this.cookieName);

			if (!this.cookieValue) {
				this.show = true;
				return;
			}

			if (this.cookieValue === 'notrack') {
				this.acceptedAnalytics = false;
				window[`ga-disable-${this.analyticsId}`] = true;
			}
		},

		accept() {
			this.setCookie(this.cookieName, this.acceptedAnalytics ? 'accept' : 'notrack', 365);
			window[`ga-disable-${this.analyticsId}`] = !this.acceptedAnalytics;
			this.show = false;
			this.dispatchCookieConsentClosed();
		},

		reject() {
			this.setCookie(this.cookieName, 'notrack', 365);
			this.show = false;
		},

		togglePrefs() {
			this.prefs = !this.prefs;
		},

		toggleShow() {
			this.show = !this.show;
		},

		toggleShow() {
			this.show = !this.show;
			if (!this.show) {
				// Dispatch event when cookie consent is manually closed
				this.dispatchCookieConsentClosed();
			}
		},

		dispatchCookieConsentClosed() {
			// Create and dispatch a custom event
			const event = new CustomEvent('cookie-consent-closed');
			window.dispatchEvent(event);
		},

		setCookie(name, value, days = 28) {
			const d = new Date();
			d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);

			const attributes = [
				name + '=' + value,
				'path=/',
				'expires=' + d.toUTCString(),
				'samesite=strict',
			];

			if (document.location.protocol.includes('https')) {
				attributes.push('secure');
			}

			document.cookie = attributes.join(';');
		},

		getCookie(name) {
			const value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
			return value ? value[2] : null;
		},
	};
}
